'use strict';
const mmWidgets = require('./mm-widgets');

require('./dispatched-event-value-widget');

mmWidgets.fn.accountInfoValueWidget = function (subscriptionModel) {
	return mmWidgets(this).dispatchedEventValueWidget(subscriptionModel, ['subscribed', 'expiredSubscription', 'accountRegistered'], 'mm-subscription-value');
};
